import Swiper from "swiper/bundle";
import { initInstaFeed } from "../components/instaFeed"

const [ w, d, mq ] = [window, document, window.matchMedia( "(max-width: 900px)" ) ];
const domReady = TPL => {
  new BLOCKS;
};

class BLOCKS {
  constructor() {
    this.mainvisual();
    this.shopnews();
    this.event();
    this.rakuichi();
    this.floor();
    initInstaFeed();
  }
  
  mainvisual () {
    let Mv = document.querySelector('.mainvisual');
    w.addEventListener('load', function() {
      Mv.classList.add('loaded');
    });

    const thumbSlide = new Swiper(".mainvisual__thumb-slide", {
    });
    //メインスライダー
    const mainSlide = new Swiper('.mainvisual__slide',{
      slidesPerView: 1,
      // simulateTouch: true,
      allowTouchMove:	false,
      autoplay:{
        delay: 5000,
        disableOnInteraction: false,
        waitForTransition: false
      },
      navigation: {
        nextEl: '.main-next',
        prevEl: '.main-prev'
      },
      thumbs: {
        swiper: thumbSlide,
      },
    });
  }

  shopnews () {
    if(!mq.matches){
      const shopnewsSlide = new Swiper('.p-top-shopnews__list',{
        speed: 1200,
        slidesPerView: 'auto',
        spaceBetween: 30,
        simulateTouch: true,
        autoplay:{
          delay: 6000,
          disableOnInteraction: false,
          waitForTransition: false
        },
        navigation: {
          nextEl: '.shopnews-next',
          prevEl: '.shopnews-prev'
        },
        scrollbar: {
          el: '.shopnews-scrollbar',
          draggable: true,
        },
      });
    }
  }

  event () {
    if(!mq.matches){
      const eventSlide = new Swiper('.p-top-event__list',{
        speed: 1200,
        slidesPerView: 'auto',
        spaceBetween: 30,
        simulateTouch: true,
        autoplay:{
          delay: 6000,
          disableOnInteraction: false,
          waitForTransition: false
        },
        navigation: {
          nextEl: '.event-next',
          prevEl: '.event-prev'
        },
        scrollbar: {
          el: '.event-scrollbar',
          draggable: true,
        },
      });
    }
  }

  rakuichi() {
    if (!mq.matches) {
      const triggerSection = document.querySelector('.p-top-event');
      const targetImage = document.querySelector('.p-top-rakuichi__img');

      if (!triggerSection || !targetImage) return;

      const options = {
        root: null,
        rootMargin: '0px 0px -100% 0px', 
        threshold: 0
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            targetImage.classList.add('is-fullsize');
          } else {
            targetImage.classList.remove('is-fullsize');
          }
        });
      }, options);

      observer.observe(triggerSection);
    }
  }

  floor() {
    const section = document.querySelector('.p-top-floor');
    const links = document.querySelectorAll('.p-top-floor__link');

    if (!section || links.length === 0) return;

    links.forEach(link => {
      const floorValue = link.dataset.floor;

      if (!floorValue) return;

      link.addEventListener('mouseenter', () => {
        section.classList.add(`is-${floorValue}`);
      });

      link.addEventListener('mouseleave', () => {
        section.classList.remove(`is-${floorValue}`);
      });
    });
  }

}

// instaAPI
// async function instaAPI() {
//   const container = d.getElementById('instaFeedWrap');
//   container.innerHTML = "";
//   container.insertAdjacentHTML('beforeend', '<ul id="instaFeed" class="p-insta__list"></ul>');
  
//   const cards = 9; // insta投稿の表示件数を指定
//   const businessId = '17841449509384596';
//   // 個人アカウント
//   const token = 'EAARHzCYWomMBQ8npPu4clyyZATZBachjZCx5HfWdINTgVHCal8ZBKWvba72L2F2PNsqqmxNnoklWh6Ku4ilJCfwuFGZAKnQvEWrBSKJiEZBax0lZCJU8KGqIKLVqKpM9ZCaheYZBrEz0e1UdQ5jwujiVm79tEcwD2hxGUCyFsRQTEmQOXg3wEiTinqu9XrzBl0t0eqWlI1BklZB0V9QIh7alrI';
//   // システムユーザー
//   // const token = 'EAAXAZABXa3oMBQCm1Fj7QMq3y4raw2LqbfdZCgINUKA1XSHSEjjKSE8jUtFvZADYdNBJCicsAIjxEwn8kVEqs6enwnGWN1ZC62qwT7NLbY5ZCtNk2YboENuGCZB4AkWFqF7TTO7FGNbCYu9J2PREOKsnszUsRFNaOonHZB1Wwe3enxlfSWZBosjKIg8oB4qHhSQhGzGht2CUWMU5R0jeGLEPChPp5jj1Rfqn1eQb';
//   const response = await fetch(
//     `https://graph.facebook.com/v19.0/${businessId}?fields=name,media.limit(${cards}){ caption,media_url,thumbnail_url,permalink,like_count,comments_count,media_type}&access_token=${token}`
//   );
  
//   if (response.status === 200) {
//     const resObjects = await response.json();
//     //（挙動への影響は一切無いものの）オブジェクト{resObjects.media}内のプロパティ{paging}のせいで「instaItems[1]が無いというエラー」が出るので削除して以降の処理を進めていく
//     delete resObjects.media.paging;
  
//     Object.entries(resObjects.media).forEach((instaItems) => {
//       instaItems[1].forEach((eachItem) => {
//         if (eachItem.media_url !== null) {
//           // 投稿が動画か否かを判定して{media}を変更
//           if (eachItem.media_type === 'VIDEO') {
//             eachItem.media = eachItem.thumbnail_url;
//           } else {
//             eachItem.media = eachItem.media_url;
//           }

//           document
//             .querySelector('#instaFeed')
//             .insertAdjacentHTML(
//               'beforeend',
//               `<li><a href="${eachItem.permalink}" target="_blank" rel="noopener"><img src="${eachItem.media}" alt="${eachItem.caption}" loading="lazy"></a></li>`
//             );
//         }
//       });
//     });
//   } else {
//     container.insertAdjacentHTML(
//       'beforeend',
//       `<p style="text-align:center;width:100%;">読み込めませんでした</p>`
//     );
//   }
// }

export default function HOME () {
  w.addEventListener('load', domReady);
  console.log('aaa');
}